import { useEffect, useState } from "react";
import { Gerenciamento } from "../../../services/Gerenciamento";
import { reverseToBrDate } from "../../../utils/dateTransform";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { GraphColors } from "../../../utils/graphCorlors";
import {
  IGerenciamentoDTO,
  IProducaoFinanceiraProps,
} from "../../../types/gerenciamento";
import { formatMoneyBRL } from "../../../utils/masks";
import dayjs from "dayjs";

const schema = z.object({
  dataInicio: z.string().nullable().optional(),
  dataFim: z.string().nullable().optional(),
  empresa: z.string().min(1).optional().or(z.literal("")),
});

const today = () => dayjs().format("YYYY-MM-DD");

const CidadeOptions = [
  {
    label: "Log",
    value: "Log",
  },
  {
    label: "Starcheck",
    value: "Starcheck",
  },
  {
    label: "Tokyo",
    value: "Tokyo",
  },
  {
    label: "Velox",
    value: "Velox",
  },
];

export const useFinancialProductionReport = () => {
  const { setIsLoad } = useContextSite();
  const [dataLinear, setDataLinear] = useState([]);
  const [axisLinear, setAxisLinear] = useState([]);

  const [dataFinanceira, setDataFinanceira] = useState<IGerenciamentoDTO>(
    {} as IGerenciamentoDTO
  );

  const [dataFilter, setDataFilter] = useState<IProducaoFinanceiraProps>({
    dataInicio: today(),
    dataFim: today(),
    empresa: "",
  });

  const { control, handleSubmit, setValue, watch } =
    useForm<IProducaoFinanceiraProps>({
      defaultValues: dataFilter,
      mode: "all",
      resolver: zodResolver(schema),
    });

  function getFinanceiro(filter: IProducaoFinanceiraProps) {
    setIsLoad(true);
    Gerenciamento.producaoFinanceira(filter)
      .then(({ data }) => {
        formatLineChartData(data.producaoDiaria);
        setDataFinanceira(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  const formatLineChartData = (data) => {
    const dates = [];
    const series = data.map((empresa) => {
      empresa.producao.forEach((producao) => {
        if (!dates.includes(producao.data)) {
          dates.push(producao.data);
        }
      });
      return {
        label: empresa.empresa,
        data: empresa.producao.map((producao) => producao.faturamento /100),
        color: GraphColors[empresa?.empresa],
        valueFormatter: (value) => formatMoneyBRL(value),
      };
    });

    setDataLinear(series);
    setAxisLinear(dates.map(reverseToBrDate));

    return { dates: dates.map(reverseToBrDate), series };
  };

  useEffect(() => {
    getFinanceiro(dataFilter);
  }, [dataFilter]);

  return {
    handleFilter: setDataFilter,
    dataFilter,
    dataFinanceira,
    dataLinear,
    axisLinear,
    control,
    handleSubmit,
    setValue,
    watch,
    CidadeOptions,
    GraphColors,
  };
};
